/**
 * Read a theme color from the CSS variables, so canvas charts follow the
 * design that is active for the element, e.g. `themeColor(el, 'primary-900')`.
 */
export function themeColor(element, name) {
  return getComputedStyle(element).getPropertyValue(`--color-${name}`).trim();
}
